import { AxiosResponse } from 'axios'
import { RateSet } from '@libs/types/generated/rates-research-api'
import { RatePairings } from '../../types/rate-set'
import { RateSetUpdateableFields } from '../../components/RateSet/RateSetUpdate'
// eslint-disable-next-line @nx/enforce-module-boundaries
import { BulkStatusUpdate } from '../../../../rates-research-api/src/types/rates'

const resources = http => ({
  getAll() {
    return http({
      method: 'get',
      url: `/rate-sets`
    })
  },

  create(newRateSet) {
    return http({
      method: 'post',
      url: '/rate-sets',
      data: newRateSet
    })
  },

  addComment(rateSetId, comment) {
    return http({
      method: 'post',
      url: `/rate-sets/${rateSetId}/comments`,
      data: { comment }
    })
  },

  details(id: number) {
    return http({
      method: 'get',
      url: `/rate-sets/${id}?withRelations=true`
    })
  },

  update(id: number, rateSet: RateSetUpdateableFields) {
    return http({
      method: 'put',
      url: `/rate-sets/${id}`,
      data: rateSet
    })
  },

  updateExpiration(id: number, expirationDate: string) {
    return http({
      method: 'put',
      url: `/rate-sets/${id}/expiration`,
      data: {
        expiration_date: expirationDate
      }
    })
  },

  review(rateSetId, decision) {
    return http({
      method: 'post',
      url: `/rate-sets/${rateSetId}/review`,
      data: { approved: decision }
    })
  },

  delete(id) {
    return http({
      method: 'delete',
      url: `/rate-sets/${id}`
    })
  },

  setRatePairs(rateSetId: number, pairs: RatePairings[]) {
    return http({
      method: 'post',
      url: '/rates/pairings',
      data: { rate_set_id: rateSetId, pairings: pairs }
    })
  },

  bulkStatusUpdate(payload: BulkStatusUpdate) {
    return http({
      method: 'post',
      url: '/rate-sets/bulk-status-update',
      data: payload
    })
  }
})

export default resources

export interface RateSetsHttpModel {
  delete: (id: number) => Promise<AxiosResponse>
  getAll: () => Promise<AxiosResponse>
  create: (payload: any) => Promise<AxiosResponse>
  details: (id: number) => Promise<AxiosResponse<RateSet>>
  review: (rateSetId: number, decision: boolean) => Promise<AxiosResponse>
  addComment: (rateSetId: number, comment: string) => Promise<AxiosResponse>
  update: (
    id: number,
    rateSet: RateSetUpdateableFields
  ) => Promise<AxiosResponse>
  updateExpiration: (
    id: number,
    expirationDate: string
  ) => Promise<AxiosResponse>
  setRatePairs: (
    id: number,
    pairs: RatePairings[]
  ) => Promise<AxiosResponse<RateSet[]>>
  bulkStatusUpdate: (payload: BulkStatusUpdate) => Promise<AxiosResponse>
}
